import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { LocalizationService } from '../shared/services/localization.service';
import { SessionStorageService } from '../shared/services/session-storage.service';
import { UserInfo } from '../shared/models/userInfo.model';
import { CommonConstants } from '../shared/constants/common.constants';

export const featuresResolver: ResolveFn<boolean> = async () => {
  const localizationService = inject(LocalizationService);
  const sessionStorageService = inject(SessionStorageService);
  const userInfo = sessionStorageService.getItem<UserInfo>(CommonConstants.SESSION_USERDETAILS);
  await localizationService.setLocaleWithUserLanguage(userInfo?.profile.languageIsoCode);
  return true;
};
